<template>
  <div>
    <UserInformation
      v-for="(item, key) in userData"
      :key="key"
      :name="key"
      :label="item.label"
      :content="item.content"
      @click-edit="showEditUserInfo(key)"
    />
    <BackTo label="マイページトップへ戻る" link="/mypage" />
  </div>
</template>

<script lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import UserInformation from '@/components/block/UserInformation.vue'
import BackTo from '@/components/block/BackTo.vue'
// import { axiosSetting } from '@/utils/axiosSetting'
import {
  getBirthdayPreviewHtml,
  getAddressPreviewHtml
} from '@/utils/commonMethods'

export default {
  name: 'MyPageUserProfile',

  components: {
    UserInformation,
    BackTo
  },

  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props: any) {
    const router = useRouter()
    const memberType = props.userInfo.member_type === '医学生' ? '1' : '2'

    const userData = computed(() => {
      let res: any = {
        hpcr_regist_status: {
          label: `ヒポクラ同時登録`,
          content:
            !props.userInfo.hpcr_regist_status ||
            props.userInfo.hpcr_regist_status === '0'
              ? ''
              : '登録済み<span class="notes">＊ 登録の解除をご希望の方は、ヒポクラの管理画面から変更をお願いします。</span>'
        },
        doctor_regist_flg: {
          label: 'マイナビDOCTOR同時登録',
          content:
            props.userInfo.doctor_regist_flg == 1
              ? '登録済み<span class="notes">＊ 登録の解除をご希望の方は、マイナビDOCTORにお問い合わせください。</span>'
              : ''
        },
        line: {
          label: 'LINEアカウントとの連携',
          content: props.userInfo.login_type === 'LINE' ? '登録済み' : ''
        },
        member_type: {
          label: '現在の職種',
          content: props.userInfo.member_type || ''
        },
        name: {
          label: '姓名（漢字）',
          content: props.userInfo.name_sei + props.userInfo.name_mei
        },
        name_kana: {
          label: '姓名（カナ）',
          content: props.userInfo.kana_sei + props.userInfo.kana_mei
        },
        gender: {
          label: '性別',
          content: props.userInfo.gender || ''
        },
        birthday: {
          label: '生年月日',
          content: getBirthdayPreviewHtml(props.userInfo.birthday)
        },
        email: {
          label: 'メールアドレス',
          content: props.userInfo.email || ''
        },
        address: {
          label: '住所',
          content: getAddressPreviewHtml(
            props.userInfo.zip,
            props.userInfo.prefecture,
            props.userInfo.city,
            props.userInfo.town
          )
        },
        tel: {
          label: '電話番号',
          content: props.userInfo.tel || ''
        },
        vacation_address: {
          label: '休暇中住所',
          content: props.userInfo.vacation_flg
            ? '登録の住所と同じ'
            : getAddressPreviewHtml(
                props.userInfo.zip_vacation,
                props.userInfo.prefecture_vacation,
                props.userInfo.city_vacation,
                props.userInfo.town_vacation
              )
        },
        school_id: {
          label: '大学名',
          content: props.userInfo.school_id || ''
        },
        graduate_year: {
          label: '卒業時期(年)',
          content: props.userInfo.graduate_year
            ? props.userInfo.graduate_year + '年'
            : ''
        }
      }

      if (memberType === '2') {
        const obj = {
          work_place: {
            label: '現勤務先',
            content: props.userInfo.work_place || ''
          },
          licensing_year: {
            label: '医師免許取得年',
            content: props.userInfo.licensing_year
              ? props.userInfo.licensing_year + '年'
              : ''
          }
        }
        res = Object.assign({}, res, obj)
      }

      const obj = {
        hope_prefectures: {
          label: '希望勤務地',
          content:
            props.userInfo.hope_prefectures.length > 0
              ? props.userInfo.hope_prefectures.join('、')
              : ''
        },
        hope_keywords: {
          label: '希望するこだわり条件',
          content:
            props.userInfo.hope_keywords.length > 0
              ? props.userInfo.hope_keywords.join('、')
              : ''
        }
        // hope_hospital_class: {
        //   label: '希望する病院種別',
        //   content: props.userInfo.hope_hospital_class
        //     ? props.userInfo.hope_hospital_class
        //     : ''
        // }
      }
      res = Object.assign({}, res, obj)

      if (memberType === '2') {
        const hopedDiagnosis = props.userInfo.hoped_diagnosis.filter(
          (val: string) => val !== ''
        )
        const obj = {
          hoped_diagnosis: {
            label: '希望科目',
            content: hopedDiagnosis.length > 0 ? hopedDiagnosis.join('、') : ''
          }
        }
        res = Object.assign({}, res, obj)
      }
      // 必ず末尾にメルマガ配信を追加したい
      const lastObj = {
        main_email_flg: {
          label: 'メールマガジン配信',
          content:
            props.userInfo.main_email_flg === 1
              ? '配信を希望する'
              : '配信を希望しない'
        }
      }
      res = Object.assign({}, res, lastObj)

      return res
    })

    const showEditUserInfo = (key: string) => {
      router.push(`/mypage/user/profile/${key}`)
    }

    return {
      userData,
      showEditUserInfo
    }
  }
}
</script>

<style lang="scss" scoped></style>
